import {http} from '../../../Lib/Http/httpClient';
import {set} from '../../Algorithm/BidAsc/reducer';

export function getBidAsc(params) {
	return (dispatch) => {
		return http.request('get', 'pairs/getBidAsc', {params: params, cache: {maxAge: 0}}).then(response => {
			dispatch(set(response.data.data));
		});
	};
}

export function getTokenKucoin() {
	return http.request('get', 'brokers/kucoin/token', {cache: {maxAge: 0}}).then(response => response.data.data);
}
